const accordions = document.querySelectorAll(".js-accordion");

if (accordions) {
    accordions.forEach(accordion => {
        const toggle = accordion.querySelector(".accordion__title");

        toggle.addEventListener("click", (e) => {
            accordion.classList.toggle("open");
        });
    });
}